import type {
  QuestionnaireItem,
  QuestionnaireResponseItem,
} from '@medplum/fhirtypes'

/**
 * Flattens `Questionnaire` or `QuestionnaireResponse` items into a flat array.
 * Depth-first search.
 */
export function flattenQuestionnaireItems<
  T extends QuestionnaireItem | QuestionnaireResponseItem,
>(withItem: { item?: T[] }): T[] {
  return (withItem.item?.flatMap((item) => [
    item,
    ...flattenQuestionnaireItems(item as never),
  ]) ?? []) as T[]
}
